module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<form class="drop-target">\n    <div class="drop-info-box">\n        <p class="drop-target-message"></p>\n        <div class="icon"></div>\n    </div>\n    <input type="file" class="upload" multiple title="click here to upload">\n</form>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/behaviors/DropAreaHotspot.tpl
// module id = 1727
// module chunks = 0